import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
  },
  overdue: {
    color: '#FA5252',
  },
  cursorDefault: {
    cursor: 'pointer',
  },
  link: {
    '& a': {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      fontWeight: theme.typography.fontWeightMedium,
      '&:hover': {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },
  searchIcon: {
    '& svg': {
      color: theme.palette.secondary.light,
      fontSize: theme.typography.pxToRem(14),
    },
  },
}));

export default useStyles;
